import React, {useContext} from 'react';
import { NavLink } from 'react-router-dom';
import UserContext from '../contexts/UserContext';
import withDropdown from './withDropdown';

function UserNavbarDropdown(props) {
    const userContext = useContext(UserContext)
    const backendApiPath = process.env.REACT_APP_BACKEND_API_PATH
    return (
        <div className="navbar-item" style={{
            display: 'flex',
            alignItems: 'center'
        }}>
            <div className="post-profile-pic">
                <div className="pic-container" style={{
                    margin: 0,
                    marginRight: 5,
                    width: 30,
                    height: 30
                }}>
                    <img src={`${backendApiPath}/profile/${userContext.currentUser}/pic`} height="30" width="40" />
                </div>
            </div>
            {userContext.currentUser}
        </div>
    );
}

export default withDropdown(UserNavbarDropdown, [<NavLink className="dropdown-item" key="logout" to="/logout">Logout</NavLink>], {marginRight: 20});